import { MBText } from '@shared/components/MBText';
import { Colors } from '@shared/styles';
import { API } from '@shared/types/api';
import { i18n } from '@shared/util/i18n';
import { MBBaseChatBanner } from './base';

interface MBMeChatBannerProps {
  user: API.ShortUserFragment;
  channel: API.ChannelChatThreadFragment;
}

export function MBMeChatBanner({ user, channel }: MBMeChatBannerProps) {
  return (
    <MBBaseChatBanner title={channel.name} subtitle={`@${user.username}`} channel={channel}>
      <MBText color={Colors.v2.greenSecondary90}>{i18n('chat.banner.yourSpace')}</MBText>
    </MBBaseChatBanner>
  );
}
